import { h } from 'preact';
import { useCallback } from 'preact/hooks';
import { USER_CLICK, USER_PIP } from '../../../../types';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import { LabeledButton, OverlayScreen } from '../common';
import { OVERLAY_WRAPPER } from './styles';

function PIPView() {
  const player = usePlayerContext();
  const { isPIP } = useNewStore('ui', player);

  const pipButton = useCallback(() => (
    <div style={OVERLAY_WRAPPER}>
      <span>Lecture picture-in-picture activée</span>
      <LabeledButton
        label="Désactiver"
        onClick={() => {
          player.userEvents$.next({
            action: USER_PIP,
            value: false,
            source: USER_CLICK
          });
          player.requestPIP(false);
        }}
      />
    </div>
  ), []);

  return (
    isPIP ? (
      <OverlayScreen
        opaque
        component={pipButton}
      />
    ) : null
  );
}

export default PIPView;
